<template>
  <div class="row">
    <div class="col-12">
      <p class="lead">Análise de Risco</p>
    </div>
  </div>
  <div class="row mb-3 no-print">
    <div class="col-12">
      <router-link
        :to="{ name: 'preliminary-risk-analyses' }"
        class="btn btn-primary"
      >
        <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
        Voltar para AR
      </router-link>

      <a
        v-if="machineId && authenticated_user !== 'Cliente somente leitura'"
        @click="goToNewAnalysis"
        class="btn btn-success ml-2"
      >
        Nova Análise
      </a>
    </div>
  </div>

  <div class="row mb-3" v-if="risks?.length > 0">
    <div class="col-12 d-flex">
      <label class="mr-2">
        {{ risks?.length == 1 ? 'Categoria de risco selecionada' : 'Categorias de risco selecionadas' }}:
      </label>
      <div v-for="risk in risks" :key="risk" class="mr-2">
        <div
          class="risk-category"
          :class="{ unacceptable: risk === 8 }"
          :style="`background-color: ${getHrnLevelColor(risk)}`"
        >
          {{ getRiskCategoryLabel(risk) }}
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-3" v-if="machine">
    <div class="col-12">
      <machine-header
        :machine="machine"
        :max-metrics="max_metrics"
        :is-company-mondelez="isCompanyMondelez"
      ></machine-header>
    </div>
  </div>
  <div
    class="row machine-inventory"
    v-if="machine && !isCompanyMosaic()"
  >
    <div class="col-12">
      <machine-inventory-table
        :machine="machine"
        :safety-systems="safety_systems"
      ></machine-inventory-table>
    </div>
  </div>
  <div class="row machine-aprs mt-3">
    <div class="col-12">
      <machine-apr-list
        :machine-aprs="machine_aprs"
        :is-company-mondelez="isCompanyMondelez"
      ></machine-apr-list>
    </div>
  </div>
</template>

<script>
  import MachineAprList from './components/MachineAprList.vue'
  import MachineHeader from './components/MachineHeader.vue'
  import MachineInventoryTable from './components/MachineInventoryTable.vue'
  import { MONDELEZ_ID } from '@/constants/config.constants.js'
  import { useStore } from 'vuex'
  import { computed } from '@vue/runtime-core'
  import { useRoute, useRouter } from 'vue-router'
  import useHrn from '@/modules/Hrn'
  import { MOSAIC_FERTILIZANTES_ID } from '@/constants/config.constants.js'

  export default {
    setup() {
      const route = useRoute()
      const router = useRouter()
      const store = useStore()
      const selected_company = computed(() => store.getters.selected_company)
      const authenticated_user = computed(() => store.getters.authenticated_user.user_profile.name)

      const risks = route?.params?.risks?.map(risk => parseInt(risk))

      const { getHrnLevelColor } = useHrn()

      const adequacy_status = [
        { label: 'Conforme', value: 0 },
        { label: 'Aceitável', value: 1 },
        { label: 'Muito Baixo', value: 2 },
        { label: 'Baixo', value: 3 },
        { label: 'Significante', value: 4 },
        { label: 'Alto', value: 5 },
        { label: 'Muito Alto', value: 6 },
        { label: 'Extremo', value: 7 },
        { label: 'Inaceitável', value: 8 },
      ]

      return {
        selected_company,
        machineId: route?.params?.machineId,
        router,
        risks,
        adequacy_status,
        getHrnLevelColor,
        authenticated_user
      }
    },
    components: {
      MachineHeader,
      MachineInventoryTable,
      MachineAprList,
    },
    data() {
      return {
        safety_systems: [],
        machine_aprs: [],
        max_metrics: {},
        machine: null,
        loading: false,
      }
    },
    mounted() {
      this.get()
      this.listSafetySystems()
      this.listRiskAnalysis()
      this.getMaxMetrics()
    },
    methods: {
      get() {
        var app = this

        app.axios
          .get(`/api/machines/get/${this.machineId}`)
          .then(({ data }) => {
            app.machine = data.data
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            app.loading = false
          })
      },
      getRiskCategoryLabel(risk) {
        return this.adequacy_status.filter(status => status.value == risk)[0].label
      },
      listSafetySystems() {
        var app = this

        app.axios
          .get('/api/safety_systems/all')
          .then(function (response) {
            app.safety_systems = response.data.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      async listRiskAnalysis() {
        var app = this
        const machineId = this.$route.params.machineId

        let aprs = await app.axios
          .get(`/api/machines/${machineId}/risk-analysis/all`)
          .then(response => response.data.data)
          .catch(function (error) {
            console.log(error)
            return []
          })

        if (this.risks?.length > 0) {
          aprs = aprs.filter(apr => this.risks.includes(apr.calculated_hrn_level))
        }

        app.machine_aprs = aprs
      },
      getMaxMetrics() {
        var app = this
        const machineId = this.$route.params.machineId

        app.axios
          .get(`/api/machines/${machineId}/risk-analysis/get-max-metrics`)
          .then(function (response) {
            app.max_metrics = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      goToNewAnalysis() {
        this.router.push({
          name: 'risk-analysis-create',
          params: { machineId: this.machineId },
        })
      },
      isCompanyMosaic() {
        return this.selected_company.id == MOSAIC_FERTILIZANTES_ID
      },
    },
    computed: {
      isCompanyMondelez() {
        return this.selected_company.id === MONDELEZ_ID
      },
    },
  }
</script>

<style scoped>
  .risk-category {
    padding: 2px 10px;
    border-radius: 15px;
  }

  .unacceptable {
    color: white;
  }
</style>
